export default __webpack_public_path__ + "static/media/location-pin.76613f4e.svg";